export default __webpack_public_path__ + "static/media/Search-Results–Users.cfda8f23.svg";